<div
    class="text-center fw-semibold p-3"
    data-testid="no-availability-message"
>
    <ng-container
        *ngIf="availability.noAvailabilityDescription(requiresDogFriendly, partySize, areaId, eventId, reasonId); let noAvailabilityDescription"
    >
        <span [innerHTML]="noAvailabilityDescription"></span>
    </ng-container>
    <ng-container
        *ngIf="!availability.noAvailabilityDescription(requiresDogFriendly, partySize, areaId, eventId, reasonId)"
    >
        Sorry, we don't have any tables available for your party size at this time.
        <br>
        Try a different time or party size,
        or get in touch at
        <a [href]="availability.venue.phoneNumber"> {{ availability.venue.phoneNumber }}</a>
        to see if we can help.
    </ng-container>

    <ng-container *ngIf="showJoinWaitlistButton">
        <div class="mt-3">
            <button
                class="btn btn-outline-dark btn-sm"
                (click)="joinWaitlistRequested.emit()"
                data-testid="join-waitlist-button"
            >
                Join the waitlist
            </button>
        </div>
    </ng-container>
</div>
